<!--
 * 车辆归属机构管理
-->
<template>
  <div>
    <div style="padding:10px 0;">
      <a-form-model layout="inline" :model="formInline" @submit.native.prevent>
        <a-form-model-item>
          <a-input-search v-model="formInline.keyWord" placeholder="机构名称/机构ID" allowClear enter-button @search="onSearch" />
        </a-form-model-item>
        <a-form-model-item label="AI证件核对">
          <a-select
            v-model="formInline.isAiInvoiceCheck"
            placeholder="全部"
            allowClear
            style="width: 120px"
            @change="onSearch"
          >
            <a-select-option :value="1">开启</a-select-option>
            <a-select-option :value="0">关闭</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="手动分派订单">
          <a-select
            v-model="formInline.isManualDispatch"
            placeholder="全部"
            allowClear
            style="width: 120px"
            @change="onSearch"
          >
            <a-select-option :value="1">开启</a-select-option>
            <a-select-option :value="0">关闭</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item v-if="permissions.indexOf('carInstitution:add') > -1">
          <a-button type="primary" icon="plus" @click="addInstitution" />
        </a-form-model-item>
      </a-form-model>
    </div>

    <a-table :columns="columns" bordered :data-source="data" :rowKey="record => record.id" :pagination="pagination" :loading="loading" @change="handleTableChange" size="middle">
      <template slot="isAiInvoiceCheck" slot-scope="record">
        <a-switch
          :checked="record.isAiInvoiceCheck == 1"
          :disabled="permissions.indexOf('carInstitution:aiCheck') < 0"
          checked-children="开"
          un-checked-children="关"
          @change="(checked) => onAiCheckChange(record, checked)"
        />
      </template>
      <template slot="isManualDispatch" slot-scope="record">
        <a-switch
          :checked="record.isManualDispatch == 1"
          :disabled="permissions.indexOf('carInstitution:manualDispatch') < 0"
          checked-children="开"
          un-checked-children="关"
          @change="(checked) => onManualDispatchChange(record, checked)"
        />
      </template>
      <template slot="operation" slot-scope="record">
        <a-space>
          <a-button type="primary" size="small" v-if="permissions.indexOf('carInstitution:edit') > -1" icon="edit" @click="editInstitution(record)" />
          <a-button type="danger" size="small" v-if="permissions.indexOf('carInstitution:delete') > -1" icon="delete" @click="delInstitution(record)" />
        </a-space>
      </template>
    </a-table>

    <!-- 新增/编辑 -->
    <a-drawer :title="title" :width="400" :visible="visibleAddEdit" @close="onClose">
      <a-form-model ref="ruleForm" :model="form" :rules="rules">
        <a-form-model-item label="机构ID" prop="institutionId">
          <a-input
            v-model="form.institutionId"
            placeholder="请输入机构ID"
            :disabled="isEdit"
            :readonly="isEdit"
          />
        </a-form-model-item>
        <a-form-model-item label="机构名称" prop="institutionName">
          <a-input v-model="form.institutionName" placeholder="请输入机构名称" />
        </a-form-model-item>
        <a-form-model-item label="手动分派订单">
          <a-switch
            v-model="form.isManualDispatch"
            :checked="form.isManualDispatch == 1"
            checked-children="开"
            un-checked-children="关"
          />
          <div style="color: rgba(0,0,0,0.45); font-size: 12px; line-height: 1.5; margin-top: 4px;">
            开启后该机构的订单将不参与自动派单，需手动分派给供应商
          </div>
        </a-form-model-item>
      </a-form-model>
      <div class="ml_drawer_footer">
        <a-button @click="onClose">取消</a-button>
        <a-button style="margin-left: 10px" type="primary" @click="onSubmit">确定</a-button>
      </div>
    </a-drawer>

  </div>
</template>
<script>
import {
  getCarInstitutionList,
  addCarInstitution,
  updateCarInstitution,
  updateCarInstitutionAiCheck,
  updateCarInstitutionManualDispatch,
  getCarInstitution,
  delCarInstitution
} from "@/api/carInstitution";

import { mapState } from "vuex";

const columns = [
  { title: "主键ID", dataIndex: "id", align: "center" },
  { title: "机构ID", dataIndex: "institutionId", align: "center" },
  { title: "机构名称", dataIndex: "institutionName", align: "center" },
  { title: "是否开启AI证件核对", scopedSlots: { customRender: "isAiInvoiceCheck" }, align: "center" },
  { title: "手动分派订单", scopedSlots: { customRender: "isManualDispatch" }, align: "center" },
  { title: "创建人", dataIndex: "createUserName", align: "center" },
  { title: "创建时间", dataIndex: "createTime", align: "center" },
  { title: "更新时间", dataIndex: "updateTime", align: "center" },
  { title: "操作", scopedSlots: { customRender: "operation" }, align: "center" }
];

export default {
  data() {
    return {
      columns,
      data: [],
      loading: false,
      pagination: {
        pageSize: 10,
        pageSizeOptions: ["10", "20", "30", "40"],
        showSizeChanger: true,
        current: 1,
        total: 0
      },
      visibleAddEdit: false,
      isEdit: false,
      formInline: {
        keyWord: "",
        // AI证件核对开关筛选（null/undefined-全部，1-开启，0-关闭）
        isAiInvoiceCheck: undefined,
        // 手动分派开关筛选（null/undefined-全部，1-开启，0-关闭）
        isManualDispatch: undefined
      },
      title: "",
      form: {
        id: "",
        institutionId: "",
        institutionName: "",
        isManualDispatch: 0
      },
      rules: {
        institutionId: [{ required: true, message: "请输入机构ID" }],
        institutionName: [{ required: true, message: "请输入机构名称" }]
      }
    };
  },
  computed: {
    ...mapState({
      permissions: state => state.userStore.permissions
    })
  },
  mounted() {
    this.getList();
  },
  methods: {
    onSearch() {
      // 搜索/筛选条件变化时回到第一页，翻页时不重置
      this.pagination.current = 1;
      this.getList();
    },
    getList() {
      const that = this;
      that.loading = true;
      const params = {
        keyWord: that.formInline.keyWord,
        pageNum: that.pagination.current,
        pageSize: that.pagination.pageSize,
        _: new Date().getTime()
      };
      // 筛选有明确值（0 / 1）时传，undefined 时不传
      if (that.formInline.isAiInvoiceCheck !== undefined && that.formInline.isAiInvoiceCheck !== null) {
        params.isAiInvoiceCheck = that.formInline.isAiInvoiceCheck;
      }
      if (that.formInline.isManualDispatch !== undefined && that.formInline.isManualDispatch !== null) {
        params.isManualDispatch = that.formInline.isManualDispatch;
      }
      getCarInstitutionList(params)
        .then(res => {
          that.loading = false;
          that.data = res.data.list;
          that.pagination.total = res.data.total;
        })
        .catch(() => {
          that.loading = false;
        });
    },
    onClose() {
      const that = this;
      that.$refs.ruleForm.resetFields();
      that.visibleAddEdit = false;
    },
    handleTableChange(pagination) {
      this.pagination = { ...pagination };
      this.getList();
    },
    addInstitution() {
      const that = this;
      that.isEdit = false;
      that.visibleAddEdit = true;
      that.title = "新增机构";
      that.form = { id: "", institutionId: "", institutionName: "", isManualDispatch: 0 };
    },
    editInstitution(e) {
      const that = this;
      that.isEdit = true;
      that.visibleAddEdit = true;
      that.title = "编辑机构";
      getCarInstitution(e.id).then(res => {
        const record = res.data || {};
        that.form = {
          id: record.id,
          institutionId: record.institutionId,
          institutionName: record.institutionName,
          isManualDispatch: record.isManualDispatch || 0
        };
      });
    },
    onAiCheckChange(record, checked) {
      const that = this;
      const oldVal = record.isAiInvoiceCheck;
      record.isAiInvoiceCheck = checked ? 1 : 0; // 乐观更新，开关立即切换
      updateCarInstitutionAiCheck({ id: record.id, isAiInvoiceCheck: checked ? 1 : 0 })
        .then(() => {
          that.$message.success({
            content: checked ? "已开启AI证件核对" : "已关闭AI证件核对",
            duration: 1
          });
        })
        .catch(() => {
          record.isAiInvoiceCheck = oldVal; // 失败回滚
          that.getList();
        });
    },
    onManualDispatchChange(record, checked) {
      const that = this;
      this.$confirm({
        title: checked ? "确认开启手动分派？" : "确认关闭手动分派？",
        content: checked
          ? "开启后该机构订单将不参与自动派单，需手动分派给供应商"
          : "关闭后该机构订单将恢复自动派单",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          return updateCarInstitutionManualDispatch({ id: record.id, isManualDispatch: checked ? 1 : 0 })
            .then(() => {
              record.isManualDispatch = checked ? 1 : 0;
              that.$message.success({
                content: checked ? "已开启手动分派" : "已关闭手动分派",
                duration: 1
              });
            })
            .catch(() => {
              that.$message.error("操作失败，请重试");
              that.getList();
            });
        }
      });
    },
    delInstitution(e) {
      const that = this;
      that.$confirm({
        title: "是否确认删除该机构?",
        okType: "danger",
        okText: "确定",
        cancelText: "取消",
        centered: true,
        onOk() {
          delCarInstitution(e.id).then(() => {
            that.$message.success({
              content: "删除成功！",
              duration: 1,
              onClose: () => {
                that.getList();
              }
            });
          });
        },
        onCancel() {}
      });
    },
    onSubmit() {
      const that = this;
      that.$refs.ruleForm.validate(valid => {
        if (valid) {
          const payload = {
            institutionName: that.form.institutionName,
            isManualDispatch: that.form.isManualDispatch
          };
          if (that.isEdit) {
            // 编辑模式：仅传 id + 名称，机构ID 不允许变更
            payload.id = that.form.id;
            updateCarInstitution(payload).then(() => {
              that.$message.success({
                content: "修改成功！",
                duration: 1,
                onClose: () => {
                  that.visibleAddEdit = false;
                  that.getList();
                }
              });
            });
          } else {
            payload.institutionId = that.form.institutionId;
            addCarInstitution(payload).then(() => {
              that.$message.success({
                content: "添加成功！",
                duration: 1,
                onClose: () => {
                  that.visibleAddEdit = false;
                  that.getList();
                }
              });
            });
          }
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.ml_drawer_footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
}
</style>
